import React, { useMemo } from 'react';
import { translate } from '../../Services/translation';

interface ProgressBarProps {
  progress?: number;
  maxProgress?: number;
  showLabel?: boolean;
}

const ProgressBar = ({
  progress = 0,
  maxProgress = 100,
  showLabel = true,
}: ProgressBarProps) => {
  if (maxProgress == 0) console.warn('maxProgress cannot be 0');

  const progressPercent = useMemo(
    () => Math.min((progress / maxProgress) * 100, 100),
    [progress, maxProgress]
  );

  return (
    <>
      <div className="relative rounded-[4ppx] h-[10px] w-full mt-4 bg-gray-300">
        <div
          className="z-10 bg-gray-900 rounded-[4px] h-full transition-[width]"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      {showLabel && (
        <label className="text-md text-center mt-4">
          {translate('progress-bar.label')
            .replace('{0}', progress)
            .replace('{1}', maxProgress)}
        </label>
      )}
    </>
  );
};

export default ProgressBar;
